export default class CreateCardRequest {
    accountId: string; // FI Only
    walletId: string; // UX Only
    personId: string; // UX Only
    cardAccountIdentifier: string = '';
    thirdPartyRequiredFields: {}; // UX Only
    cardProcessor: string;
    enabled: boolean = true;
}